import { STATIC_PROPOSALS } from '../data/staticProposals';
import { programGridByNiche } from '../views/landingPages/TNOBusinessLevel/businessLevelPresentationData';

const isProgramKit = (kit) => kit?.type === 'program' && kit?.isActive !== false;

/** Slug de la grilla que apunta al mismo media kit que otro slug canónico. */
const GRID_SLUG_ALIASES = {
  noticiastno: 'noticias',
};

function normalizeGridSlug(slug) {
  const s = String(slug || '').trim();
  return GRID_SLUG_ALIASES[s] || s;
}

function slugFromHref(href) {
  const m = String(href || '').match(/\/show\/([^/?#]+)/i);
  return m ? decodeURIComponent(m[1]).trim() : '';
}

/** Shows únicos de la grilla comercial (parrilla por nichos). */
export function collectGridProgramShows() {
  const seen = new Set();
  const out = [];
  programGridByNiche.forEach((group) => {
    (group.programs || []).forEach((program) => {
      const raw = String(program.showSlug || slugFromHref(program.href) || '').trim();
      const slug = normalizeGridSlug(raw);
      if (!slug || seen.has(slug)) return;
      seen.add(slug);
      out.push({
        slug,
        name: program.name,
        note: program.note,
      });
    });
  });
  return out;
}

/**
 * Biblioteca completa de media kits de programa: estáticos + API + grilla.
 */
export function mergeProgramMediaKitLibrary(apiProposals = []) {
  const bySlug = new Map();

  STATIC_PROPOSALS.filter(isProgramKit).forEach((p) => {
    bySlug.set(p.slug, { ...p, _fromStatic: true });
  });

  (apiProposals || []).forEach((apiP) => {
    if (!apiP?.slug) return;
    const existing = bySlug.get(apiP.slug);
    if (apiP.type === 'program' && apiP.isActive !== false) {
      bySlug.set(apiP.slug, existing
        ? { ...existing, ...apiP, type: 'program', _fromStatic: existing._fromStatic && apiP._fromStatic }
        : { ...apiP, _fromStatic: false });
      return;
    }
    if (existing?.type === 'program') return;
    if (existing && apiP.type !== 'program') return;
    if (!existing && apiP.type === 'program') {
      bySlug.set(apiP.slug, { ...apiP, _fromStatic: false });
    }
  });

  collectGridProgramShows().forEach(({ slug, name, note }) => {
    if (bySlug.has(slug)) return;
    bySlug.set(slug, {
      type: 'program',
      slug,
      name,
      metaTitle: `${name} | Anuncia con nosotros`,
      metaDescription: note || `Propuesta comercial de ${name} en TNO Network.`,
      isActive: true,
      order: 999,
      _fromStatic: false,
    });
  });

  return Array.from(bySlug.values()).sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
}
